import {observer} from "mobx-react";
import {FieldSelect, UploadElement} from "../../../ui";
import {DocumentTypeDto} from "../../../../api/sea";
import {convertDocumentType} from "../../../../api";
import {DocumentFormCorI} from "./DocumentFormCorI";
import {DocumentFormCorII} from "./DocumentFormCorII";
import {DocumentFormDefault} from "./DocumentFormDefault";
import {useEffect, useState} from "react";
import {DocumentFormProps} from "./DocumentForm";
import {DocumentFormCoverLetterEnvelope} from "./DocumentFormCoverLetterEnvelope";

function getView(t: DocumentTypeDto) {
    switch (t) {
        case DocumentTypeDto.COR_I:
            return DocumentFormCorI
        case DocumentTypeDto.COR_II:
            return DocumentFormCorII
        case DocumentTypeDto.COC:
            return DocumentFormDefault
        case DocumentTypeDto.ABE:
            return DocumentFormDefault
        case DocumentTypeDto.CERT:
            return DocumentFormDefault
        case DocumentTypeDto.ENVELOPE:
            return DocumentFormCoverLetterEnvelope
        case DocumentTypeDto.COVER_LETTER:
            return DocumentFormCoverLetterEnvelope
        case DocumentTypeDto.CONTRACT:
            return DocumentFormDefault
        case DocumentTypeDto.SALARY_STATEMENT:
            return DocumentFormDefault
        case DocumentTypeDto.ID_CARD:
            return DocumentFormDefault
        case DocumentTypeDto.OTHER:
            return DocumentFormDefault

    }
}

const documentDropDownOptions = Object.keys(DocumentTypeDto).map(e => ({
    value: e,
    label: convertDocumentType(e as DocumentTypeDto)
}))

function PdfViewer({file}: { file: File }) {
    const [fileURL, setFileURL] = useState<string>('')
    useEffect(() => {
        setFileURL(URL.createObjectURL(file))
    }, [file]);
    return <>
        {fileURL && <embed
            type="application/pdf"
            style={{
                flex: '1',
                width: '100%'
            }}
            width={"100%"}
            height={"100%"}
            src={fileURL}
            onLoad={() => {
                URL.revokeObjectURL(fileURL)
            }}
        ></embed>}
    </>
}

const ScanDocumentView = observer(function ScanDocumentView({
                                                                disabled,
                                                                value,
                                                                validation,
                                                                onBlur,
                                                                onChange
                                                            }: DocumentFormProps) {

    const {
        file,
        type
    } = value

    const FormView = type ? getView(type) : undefined
    return <>
        <div className={"columns"}>
            <div className={"column is-half"}>
                {!file && <UploadElement
                    framed={true}
                    value={file}
                    formatsString={'pdf'}
                    acceptedTypes={[
                        'application/pdf'
                    ]}
                    upload={async (f) => {
                        onChange({
                            ...value,
                            file: f
                        })

                    }}
                    fileError={async () => {
                        onChange({
                            ...value,
                            file: undefined
                        })
                    }}
                />}
                {file && <PdfViewer file={file}/>}
            </div>
            <div className={"column is-half"}>
                <div className={"columns"}>
                    <div className={"column is-full"}>
                        <FieldSelect
                            disabled={disabled}
                            label={'Dokumentenart'}
                            options={documentDropDownOptions}
                            value={type || ''}
                            required={true}
                            help={validation.type}
                            invalid={Boolean(validation.type)}
                            onChange={e => {
                                onChange({
                                    ...value,
                                    type: e as DocumentTypeDto
                                })
                                onBlur()
                            }}
                        />
                    </div>
                </div>
                {FormView &&
                    <div className={"columns"}>
                        <div className={"column is-full"}>
                            <FormView
                                disabled={disabled}
                                onChange={v => onChange(v)}
                                validation={validation}
                                onBlur={() => !disabled && onBlur()}
                                value={value}
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    </>
})

export {
    ScanDocumentView
}
